/**
 * DevExtreme (esm/__internal/ui/collection/base.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import CollectionWidget from "../../../ui/collection/ui.collection_widget.base";
import Widget from "../widget";
var TypedCollectionWidget = CollectionWidget;
export default TypedCollectionWidget;
